import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_GLOBAL_ACCOUNTS_REQUEST, FetchGlobalAccountsFailure, FetchGlobalAccountsSuccess } from "../../actions/globalAccounts/globalAccountsActions";
import { fetchGlobalAccounts } from "../../../../services/authService";
import dataa from './dataa.json';




// Worker Saga
function* fetchGlobalAccountsSaga() {
  try {
    const payload = yield select(
      (state) => state?.globalAccountsReducer?.payload
    );
    const {start,rows,q,fq,type, userId } = payload;

    // Fetch contacts and existing nurtures
    const data = yield call(fetchGlobalAccounts, {start,rows,q,fq});

    const docs = data?.data?.response?.docs ?? [];

    const uniqueDocs = [];
    const seen = new Set();

    for (const item of docs) {
      if (!seen.has(item.companyid)) {
        seen.add(item.companyid);
        uniqueDocs.push(item);
      }
    }

    //  Assign back
    data.data.response.docs = uniqueDocs;

  yield put(FetchGlobalAccountsSuccess(data?.data?.response));
    
   
  } catch (error) {
    yield put(FetchGlobalAccountsFailure(error.message)); // change
  } 
  // console.log("dataa",dataa?.response)

}

// Watcher Saga
export function* watchGlobalAccountsSaga() {
  yield takeLatest(FETCH_GLOBAL_ACCOUNTS_REQUEST, fetchGlobalAccountsSaga);

}
